import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import TabList from "../../ui/TabList";
import { CanChuyen } from "../restapi/canChuyen";
import Loading from "../ui/loading";
import { isCuPhapMn, isLocalMode } from "../utils/common";
import ThamSoDa from "./ThamSoDa";
import ThamSoTheoLoaiCuoc from "./ThamSoTheoLoaiCuoc";
import _ from 'lodash'
import ThamSoTheoLoaiCuocMB from "./ThamSoTheoLoaiCuocMB";
import { CanChuyenParamGroup } from "./workingTypes";
import MessageEditor from "../message/messageEditor";
import Button from "../../ui/Button";
import store from "../store";
import Parser from "../restapi/parser";
import { globalDexieDb } from "../db/DexiedbLib";
type OwnProps = {
    parentState: any;
    onTabChange: (tab: number) => void;
    onDataSaved: () => void;
    saveDataTrigger: string;
}

const ThamSoCanChuyen: FC<OwnProps> = ({
    parentState,
    onTabChange,
    onDataSaved,
    saveDataTrigger,
}) => {
    const TABSMN = [
        { title: "2C" },
        { title: "3C" },
        { title: "4C" },
        { title: "Da" },
    ]
    const TABSMB = [
        { title: "Đuôi giải (B)" },
        { title: "Đầu giải (A)" },
        { title: "Tuỳ chọn" },
    ]
    const [state, setState] = useState({
        isLoading: true,
        group2C: {} as any,
        group3C: {} as any,
        group4C: {} as any,
        groupDa: {} as any,
        group2COrigin: {} as any,
        group3COrigin: {} as any,
        group4COrigin: {} as any,
        groupDaOrigin: {} as any,
        thamSoMB: {} as any,

        thamSoMBOrigin: {} as any,

        errorText: ".",
        htmlError: "",
        editingText: "",
        json: "",
        editingTextOrigin: "",
        maxHeight: "30vh",
    });
    const [activeTab, setActiveTab] = useState(0);

    function handleSwithTab(tab: number) {
        //setState(prev => ({ ...prev, activeTab: tab }))
        onTabChange(tab)
    }
    function handleOnUpdateParam(param: any) {
        //payload = { dai: dai, group: group, subGroup: subGroup, value: value }
        const { dai, group, subGroup, value, field } = param
        let tmpGroup: any;
        switch (group) {
            case "2C":
                tmpGroup = { ...state.group2C }
                break;
            case "3C":
                tmpGroup = { ...state.group3C }
                break;
            case "4C":
                tmpGroup = { ...state.group4C }
                break;
            case "Da":
                tmpGroup = { ...state.groupDa }
                break;
        }
        tmpGroup[dai][subGroup][field] = value;

    }
    // tải dữ liệu từ server
    useEffect(() => {

        // console.log('parent state changed')
        setState(prev => ({ ...prev, isLoading: true }))
        const payload = { contactId: parentState.CC.sendTo, daiList: parentState.daiQuayTrongNgay.join(",") }
        if (isCuPhapMn()) {
            setState(prev => ({ ...prev, isLoading: true }))

            CanChuyen.getCanChuyenParamGroups(payload).then((result: any) => {
                setState(prev => ({ ...prev, isLoading: false }));
                const tmpState = { ...state }
                result.data.data && result.data.data.canChuyenParamGroup.map((item: any) => {
                    const daiId = item.daiId;
                    let tmpGroup: any = {};
                    switch (item.groupId) {
                        case "2C":
                            tmpGroup = tmpState.group2C;

                            break;
                        case "3C":
                            tmpGroup = tmpState.group3C;
                            break;
                        case "4C":
                            tmpGroup = tmpState.group4C;
                            break;
                        case "Da":
                            tmpGroup = tmpState.groupDa;
                            break;
                    }
                    tmpGroup[daiId] = tmpGroup[daiId] || {}
                    tmpGroup[daiId][item.subGroup] = item
                })
                setState(prev => ({
                    ...prev, group2C: tmpState.group2C,
                    group3C: tmpState.group3C,
                    group4C: tmpState.group4C,
                    groupDa: tmpState.groupDa,
                    group2COrigin: _.cloneDeep(tmpState.group2C),
                    group3COrigin: _.cloneDeep(tmpState.group3C),
                    group4COrigin: _.cloneDeep(tmpState.group4C),
                    groupDaOrigin: _.cloneDeep(tmpState.groupDa),
                    isLoading: false,
                }))

            })
        } else {
            //Cú pháp miền bắc

            CanChuyen.getCanChuyenParamGroups(payload).then((result: any) => {

                const tmpState = { ...state.thamSoMB }
                const data = result.data.data.canChuyenParamGroup
                const giuLaiNgoaiLe = result.data.data.ngoaiLeText;
                const json = result.data.data.json;
                data.map((item: any) => {
                    tmpState[item.subGroup] = item;

                })
                const thamSoMBOrigin = _.cloneDeep(tmpState)
                setState(prev => ({
                    ...prev, thamSoMBOrigin,
                    thamSoMB: tmpState, isLoading: false,
                    htmlError: giuLaiNgoaiLe,
                    editingText: giuLaiNgoaiLe,
                    editingTextOrigin: giuLaiNgoaiLe,
                    json: json,
                }));


            })
            //setState(prev => ({ ...prev, isLoading: false }))
        }
    }, [parentState.CC.sendTo, parentState.workDate])

    useEffect(() => {
        if (saveDataTrigger == "")
            return
        if (isCuPhapMn()) {
            let changed: any[] = []
            let subGroup = ""
            let dais = parentState.daiQuayTrongNgay;
            dais.map((dai: string) => {
                ["DAU", "DUOI", "LO"].map((sub: string) => {
                    let origin = state.group2COrigin[dai][sub]
                    let cur = state.group2C[dai][sub]
                    if (!_.isEqual(origin, cur)) {
                        changed.push(cur)
                    }
                    //
                    origin = state.group3COrigin[dai][sub]
                    cur = state.group3C[dai][sub]
                    if (!_.isEqual(origin, cur)) {
                        changed.push(cur)
                    }
                    origin = state.group4COrigin[dai][sub]
                    cur = state.group4C[dai][sub]
                    if (!_.isEqual(origin, cur)) {
                        changed.push(cur)
                    }
                })
                let origin = state.groupDaOrigin[dai]["Da"]
                let cur = state.groupDa[dai]["Da"]
                if (!_.isEqual(origin, cur)) {
                    changed.push(cur)
                }
            })
            if (changed.length > 0) {
                const payload = {
                    dataRows: changed, ngoaiLeText: state.editingText,
                    contactId: parentState.CC.sendTo,
                }
                setState(prev => ({ ...prev, isLoading: true }))
                CanChuyen.saveCanChuyenParamGroups(payload).then(result => {
                    setState(prev => ({ ...prev, isLoading: false }))
                    onDataSaved()
                    if (isLocalMode()) {
                        globalDexieDb.canChuyenParamGroup.bulkPut(changed)
                    }
                })
            } else
                onDataSaved()
            console.log(changed)
        } else { // cu phap MB
            saveThamSoMB()
        }
    }, [saveDataTrigger])
    let group = ''
    if (state.isLoading)
        return (<Loading />)
    async function saveThamSoMB() {
        const arrKey = Object.keys(state.thamSoMBOrigin)
        const changed: any[] = []
        let ngoaiLeChanged = false;
        arrKey.map((key: string) => {
            let origin = state.thamSoMBOrigin[key]
            let cur = state.thamSoMB[key]

            if (!_.isEqual(origin, cur)) {
                changed.push(cur)
            }
        })
        let json = state.json
        if (state.editingText != state.editingTextOrigin) {
            ngoaiLeChanged = true
            const param = {}
            let parsed = await handleParseCanChuyenMessageMB()
            if (parsed.parseStatus != "parseOK") {
                return
            } else {
                json = JSON.stringify(parsed)

                setState(prev => ({ ...prev, json: json }))
            }
        }
        if (changed.length > 0 || ngoaiLeChanged) {
            const payload = {
                dataRows: changed,
                ngoaiLeText: state.editingText,
                json: json,
                contactId: parentState.CC.sendTo,
            }
            setState(prev => ({ ...prev, isLoading: true }))
            CanChuyen.saveCanChuyenParamGroups(payload).then(result => {
                setState(prev => ({ ...prev, isLoading: false }))
                onDataSaved()
                if (isLocalMode()) {
                    globalDexieDb.canChuyenParamGroup.bulkPut(changed)
                }
            })
        } else
            onDataSaved()
    }
    function handleDataThamSoMbChange(param: CanChuyenParamGroup) {
        const tmp = state.thamSoMB;
        tmp[param.subGroup] = param;
        setState(prev => ({ ...prev, thamSoMB: tmp }))
    }
    function handleEditorTextChange(html: string, rawText: string) {
        setState(prev => ({ ...prev, editingText: rawText }))
        console.log(state.errorText)
    }
    async function handleParseCanChuyenMessageMB() {
        const payload = {
            body: state.editingText,
            date: store.getState().global.workDate,
            time: "00:00:59",
            type: 1,
            contactId: parentState.CC.sendTo,
            curMien: "BAC",
            mien: "BAC",
            getCompactData: 1,
            getRawData: 0,
            mienCuPhapId: 1,
            tachXienMay: 3,
            soBoSo: 10,
        }
        if (isCuPhapMn()) {
            payload.curMien = "NAM"
            payload.mien = "NAM"
        }
        let result = await Parser.parseCanChuyenMessage(payload)

        let html = result.data.html;
        if (html == "")
            html = result.data.bodyViet;
        let errorText = ''
        if (result.data.parseStatus != "parseOK") {
            errorText = result.data.totalErrorText
        } else {
            errorText = "Nội dung đúng cú pháp"
            if (isLocalMode()) {
                globalDexieDb.ngoaiLe.put({
                    contactId: payload.contactId, json: JSON.stringify(result.data)
                })
            }


        }
        setState(prev => ({
            ...prev,
            htmlError: html,
            errorText,
        }))
        return result.data
    }
    ////////////////////
    if (state.isLoading)
        return (<Loading />)
    return (
        <>
            <TabList activeTab={parentState.CC.activeTab}
                tabs={isCuPhapMn() ? TABSMN : TABSMB} onSwitchTab={handleSwithTab}

            />
            {isCuPhapMn() ?
                (() => {
                    let ccParam: any;
                    switch (parentState.CC.activeTab) {
                        case 0:
                            group = '2C'
                            ccParam = state.group2C;
                            break;
                        case 1:
                            group = '3C'
                            ccParam = state.group3C;
                            break;
                        case 2:
                            group = '4C'
                            ccParam = state.group4C;
                            break;
                        case 3:
                            group = 'Da'
                            ccParam = state.groupDa;
                            break;
                        default:
                            break;
                    }
                    if (group != 'Da') {
                        let tmp: any = []
                        parentState.daiQuayTrongNgay.map((item: any, index: number) => {
                            tmp.push(<div key={'tscc' + group + index}>
                                <ThamSoTheoLoaiCuoc parentState={parentState} dai={item} group={group}
                                    canChuyenParam={ccParam}
                                    onUpdateParam={handleOnUpdateParam} />
                            </div>)
                        })
                        return tmp
                    } else {
                        //Da
                        let tmp: any = []
                        parentState.daiQuayTrongNgay.map((item: any, index: number) => {
                            tmp.push(<div key={'tscc' + group + index}>
                                <ThamSoDa parentState={parentState} dai={item} group={group}
                                    onUpdateParam={handleOnUpdateParam}
                                    canChuyenParam={ccParam} />
                            </div>)
                        })
                        return tmp
                    }
                })()
                : (() => {
                    const result: any[] = []
                    state.thamSoMB && Object.keys(state.thamSoMB).map((item: string, index: number) => {
                        const param: CanChuyenParamGroup = state.thamSoMB[item]
                        if (parentState.CC.activeTab == 0) /*đề lô B*/ {
                            switch (param.subGroup) {
                                case "De":
                                case "Giai1":
                                case "Giai2":
                                case "Giai3":
                                case "3c":
                                case "3c1":
                                case "Lo":
                                case "Xi2":
                                case "Xi3":
                                case "Xi4":
                                    result.push(<ThamSoTheoLoaiCuocMB
                                        onDataChange={handleDataThamSoMbChange}
                                        param={param}></ThamSoTheoLoaiCuocMB>)
                            }
                        } else if (parentState.CC.activeTab == 1) /*đề A*/ {
                            switch (param.subGroup) {
                                case "DeA":
                                case "Giai1A":
                                case "3cA":
                                case "3c1A":
                                case "LoA":
                                case "Xi2A":
                                case "Xi3A":
                                case "Xi4A":
                                    result.push(<ThamSoTheoLoaiCuocMB
                                        onDataChange={handleDataThamSoMbChange}
                                        param={param}></ThamSoTheoLoaiCuocMB>)
                            }
                        }
                    })
                    if (parentState.CC.activeTab == 2) {
                        const tmp = <div className=" form-main">
                            <div className=" form-header border">
                                <div className="form-header left-panel">
                                    Nhập nội dung giữ lại, cú pháp như tin cược
                                </div>
                                <div className="form-header right-panel">
                                    <Button round size="smaller"
                                        onClick={() => {
                                            handleParseCanChuyenMessageMB()
                                        }}
                                    >
                                        <i className="fa fa-check"></i>
                                    </Button>
                                </div>
                            </div>
                            <div className=" form-content">
                                <div style={"position:relative;"}>
                                    <MessageEditor onTextChange={handleEditorTextChange}
                                        onMsgTypeChange={() => { }}
                                        htmlError={state.htmlError}
                                        errorTextToUser={state.errorText}
                                        msgType={1}
                                        maxHeight={state.maxHeight}
                                        // hidenErrorText
                                        placeholder="đài chính chục 1 2 bỏ đơn vị 3 5 đá 1n , tổng chãn bỏ hàng 1,2,3  đuôi 1n"
                                    ></MessageEditor>
                                </div>
                            </div>
                        </div>

                        result.push(tmp)
                    }
                    return result;
                })()
            }

        </>
    )
}

export default memo(ThamSoCanChuyen)